import {useCallback, useRef, useState, DragEvent} from 'react';

type Props = {
  onDataTransfer: (dataTransfer: DataTransfer) => void;
};

export const useDragAndDrop = ({onDataTransfer}: Props) => {
  const [isDragging, setIsDragging] = useState(false);
  const dragTimeoutRef = useRef<NodeJS.Timeout>();

  // The drag leave event can fire while the user is still dragging over the drop zone
  const handleDragLeave = useCallback(() => {
    clearTimeout(dragTimeoutRef.current);
    dragTimeoutRef.current = setTimeout(() => {
      setIsDragging(false);
    }, 200);
  }, []);

  const handleDragOver = (event: DragEvent) => {
    event.preventDefault();
    clearTimeout(dragTimeoutRef.current);

    if (!isDragging) {
      setIsDragging(true);
    }
  };

  const handleDrop = (event: DragEvent) => {
    event.preventDefault();
    setIsDragging(false);
    onDataTransfer(event.dataTransfer);
  };

  return {
    isDragging,
    handleDragLeave,
    handleDragOver,
    handleDrop,
  };
};
